export const catalogUiContent = {
  searchPlaceholder: "Buscar productos, modelos o categorías",
  filtersLabel: "Filtros",
  sortLabel: "Ordenar por",
  addToCart: "Agregar",
  viewProduct: "Ver producto",
  relatedProductsTitle: "Productos relacionados",
  relatedProductsActionLabel: "Ver la categoría",
  categoriesTitle: "Categorías",
  categoriesSubtitle: "Todas las familias activas",
  cartTitle: "Mi pedido",
  cartEmptyTitle: "Tu pedido está vacío",
  cartEmptyBody: "Agrega productos del catálogo para enviarlos por WhatsApp.",
  orderNotePlaceholder: "Ej: Necesito entrega urgente en zona Centro...",
  sendOrder: "Enviar pedido por WhatsApp",
} as const;

export const sortOptions = [
  { value: "relevance", label: "Relevancia" },
  { value: "name", label: "Nombre" },
  { value: "price", label: "Precio" },
  { value: "availability", label: "Disponibilidad" },
] as const;

export const productTypeOptions = [
  { value: "generico", label: "Genérico" },
  { value: "original", label: "Original" },
] as const;

export const availabilityOptions = [
  { value: "available", label: "Stock disponible" },
  { value: "check_stock", label: "Consultar stock" },
  { value: "coming_soon", label: "Sin Stock" },
] as const;
